function getDomain(): string {
  return globalThis?.location?.origin;
}

function getPathname(): string {
  return globalThis?.location?.pathname ?? '';
}

function isMagnoliaPreview(pathname: string = getPathname()): boolean {
  return pathname.startsWith('/magnolia-wrapper/');
}

function containsTestOrLocalhost(domain: string) {
  return /test\.|localhost|127\.0\.0\.1/.test(domain);
}

function containsQADomain(domain: string) {
  return /qa\./.test(domain);
}

function getSubdomain(domain: string = getDomain()): string {
  if (containsTestOrLocalhost(domain)) {
    return 'test.';
  }

  if (containsQADomain(domain)) {
    return 'qa.';
  }
  // Production!
  return '';
}

function getBaseUrl(subdomain = getSubdomain()): string {
  return `https://www.${subdomain}ramseysolutions.com`;
}

/**
 * Ramsey Connect is served at the root of its own `connect.` host (see the
 * `trusted` tenant bindings in ready-player-one-web-app). Localhost resolves to
 * the test host because Ramsey Connect is never served locally. Targets the
 * `/app` landing page directly, since that is the only page that honors `?q=`
 * and the bare root just redirects to it.
 */
function getRamseyConnectBaseUrl(subdomain = getSubdomain()): string {
  return `https://connect.${subdomain}ramseysolutions.com/app`;
}

function getTaxFullUrl(
  subdomain = getSubdomain(),
  domain: string = getDomain()
): string {
  if (/localhost|127\.0\.0\.1/.test(domain)) {
    return `http://localhost:8080/tax`;
  }
  return `https://trusted.${subdomain}ramseysolutions.com/tax`;
}

export {
  getBaseUrl,
  getRamseyConnectBaseUrl,
  getSubdomain,
  getTaxFullUrl,
  isMagnoliaPreview
};
